export default {
	btn: 'Liste des spécialités',
	popup: {
		title: 'Liste des spécialités',
		btn: 'Fermer'
	},
	table: {
        title: 'Voici la liste des spécialités disponibles',
		subtitle: 'spécialité'
	}
};
